import React, { useCallback, useState } from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ValidationBoundary, Validator, ValidationState } from '@/components/validation'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import AssigneeSelector from '@/components/AssigneeSelector'

function UserSelectorDialog (props) {
  const { value, onAction } = props

  const [dialogValue, setDialogValue] = useState(value)
  const { makerUser } = dialogValue
  const isSameUser = value.makerUserId === dialogValue.makerUserId

  const onChange = useCallback((value) => {
    setDialogValue({ makerUserId: value ? value.id : null, makerUser: value })
  }, [setDialogValue])
  const onActionCallback = useCallback(() => { onAction(dialogValue) }, [onAction, dialogValue])

  const renderFooter = ({ isValid }) =>
    <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' disabled={!isValid || isSameUser} {...props} onAction={onActionCallback} />

  return <ValidationBoundary>
    <BasicHeader title='Common.SelectUser' {...props} />
    <ModalBody>
      <Validator name='value' value={dialogValue.makerUserId} required>
        <AssigneeSelector
          value={makerUser ? makerUser.name : null}
          onChange={user => onChange(user)}
        />
      </Validator>
    </ModalBody>
    <ValidationState render={renderFooter} />
  </ValidationBoundary>
}

export default {
  component: UserSelectorDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/userSelector.js